import type { WorldStats } from '../api/models';

// formatGold renders a gold total with thousands separators. Pure and
// unit-tested (the shared kind of logic §6 asks web tests to cover).
export function formatGold(gold: number): string {
  return new Intl.NumberFormat('en-US').format(gold);
}

// statsRows is the pure view-model behind the panel: label/value pairs in
// display order. Kept separate from the DOM so it can be asserted directly.
export function statsRows(stats: WorldStats): Array<[string, string]> {
  return [
    ['Kingdoms', String(stats.kingdom_count)],
    ['Nobles', String(stats.noble_count)],
    ['Gold in play', formatGold(stats.gold_in_play)],
  ];
}

export function renderStatsPanel(el: HTMLElement, stats: WorldStats): void {
  const rows = statsRows(stats)
    .map(([label, value]) => `<div><dt>${label}</dt><dd>${value}</dd></div>`)
    .join('');
  el.innerHTML = `<h1>Realm Status</h1><dl>${rows}</dl>`;
}
